/**
 * Shared mobile-friendly menu behavior for Vuetify select/autocomplete/combobox.
 * Keeps the suggestion list below the field and limits height so the keyboard
 * does not shove the menu over the input on phones.
 */
export const FORM_SELECT_MENU_PROPS = {
  location: 'bottom',
  origin: 'top',
  maxHeight: 240,
  scrollStrategy: 'reposition',
  contentClass: 'formSelectMenu',
}

/**
 * Scroll a Vuetify field into the upper third of the viewport so its dropdown
 * remains visible under the input when the mobile keyboard opens.
 * @param {HTMLElement|undefined|null} el
 */
export function scrollFormFieldIntoView(el) {
  if (!el || typeof el.scrollIntoView !== 'function') return
  try {
    el.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' })
  } catch {
    el.scrollIntoView(true)
  }
}
